// Rooh Collective — Tab & Accordion JS
// Handles tab switching and accordion behaviour across
// returns, shipping, care instructions, and size guide pages.

(function() {
  function initRoohTabs() {

    // ── Tab navigation ──────────────────────────────────────────
    var navBtns = document.querySelectorAll('.rp__nav-btn[data-tab]');
    if (navBtns.length) {
      navBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var target = this.getAttribute('data-tab');
          navBtns.forEach(function(b) { b.classList.remove('active'); });
          document.querySelectorAll('.rp__panel').forEach(function(p) { p.classList.remove('active'); });
          this.classList.add('active');
          var panel = document.getElementById('tab-' + target);
          if (panel) panel.classList.add('active');
        });
      });
    }

    // ── Region buttons (returns + shipping pages) ────────────────
    var regionBtns = document.querySelectorAll('.rp__region-btn[data-region]');
    if (regionBtns.length) {
      regionBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var region = this.getAttribute('data-region');

          regionBtns.forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');

          ['au','nz','us','uk','eu','me','row','duties','intl'].forEach(function(x) {
            var el = document.getElementById('policy-' + x) || document.getElementById('ship-' + x);
            if (el) el.style.display = (x === region) ? 'block' : 'none';
          });

          if (typeof regionData !== 'undefined' && regionData[region]) {
            var d = regionData[region];
            var ids = {
              'strip-ship-val': d.shipVal,
              'strip-ship-note': d.shipNote,
              'strip-credit-val': d.creditVal,
              'strip-credit-note': d.creditNote,
              'ocard-credit-desc': d.creditDesc,
              'ocard-credit-note': d.creditNote2,
              'ocard-exch-note': d.exchNote
            };
            Object.keys(ids).forEach(function(id) {
              var el = document.getElementById(id);
              if (el) el.textContent = ids[id];
            });

            var refundBadgeEl = document.getElementById('ocard-refund-badge');
            var refundDescEl  = document.getElementById('ocard-refund-desc');
            var refundNoteEl  = document.getElementById('ocard-refund-note');
            var refundCard    = document.getElementById('ocard-refund');
            var grid          = document.getElementById('option-cards-grid');

            if (d.refundAvail) {
              if (refundBadgeEl) refundBadgeEl.textContent = d.refundBadge;
              if (refundDescEl)  refundDescEl.textContent  = d.refundDesc;
              if (refundNoteEl)  refundNoteEl.textContent  = d.refundNote;
              if (refundCard)    refundCard.classList.remove('rp__ocard--hidden');
              if (grid)          grid.classList.add('rp__option-cards--three');
            } else {
              if (refundCard)    refundCard.classList.add('rp__ocard--hidden');
              if (grid)          grid.classList.remove('rp__option-cards--three');
            }
          }
        });
      });
    }

    // ── Accordion ────────────────────────────────────────────────
    var accBtns = document.querySelectorAll('.rp__acc-btn');
    if (accBtns.length) {
      accBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var body   = this.nextElementSibling;
          var isOpen = body && body.classList.contains('open');
          accBtns.forEach(function(b) { b.classList.remove('open'); });
          document.querySelectorAll('.rp__acc-body').forEach(function(b) { b.classList.remove('open'); });
          if (!isOpen && body) {
            body.classList.add('open');
            this.classList.add('open');
          }
        });
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRoohTabs);
  } else {
    initRoohTabs();
  }

})();